<div class="applicationcargo-pickup">
  <div>
    <!-- <h1>Заявка на забор груза</h1> -->
    <h1>Информация о заборе/доставке</h1>

    <div class="blocks-container">
      <div class="blocks-container__item">
        <el-form-item prop="applicationCargoPickup.isCargoPickup">
          <el-switch
            v-model="dataForm.applicationCargoPickup.isCargoPickup"
            active-text="Забор груза"
            disabled
          />
        </el-form-item>

        <el-form-item class="align-items--flex-end_el-form-item__content">
          <el-col :span="11">
            <el-form-item
              label="Адрес забора груза"
              prop="applicationCargoPickup.addressCargoPickup"
            >
              <el-dropdown ref="addressFromDropdown" trigger="contextmenu" class="addressFromDropdown">
                <div class="dropdown-input-area"></div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="(option, index) in fromAddressList"
                      :key="index"
                      @command="setFromAddress(option.value)"
                      :disabled="option.disabled"
                      v-bind:class="option.class"
                      >
                      {{option.value}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              <el-input
                v-model="dataForm.applicationCargoPickup.addressCargoPickup"
                placeholder="Введите адрес"
                :disabled="!dataForm.applicationCargoPickup.isCargoPickup"
                @input="getFromAddress"
                @click="clickFromAddress"
                v-cancel-read-only
                autocomplete="do-not-autofill"
              />
            </el-form-item>
          </el-col>
          <el-col :span="2" />
          <el-col :span="11">
            <el-form-item
              label="Дата забора"
              prop="applicationCargoPickup.pickupDate"
            >
              <el-date-picker
                style="width: auto"
                v-model="dataForm.applicationCargoPickup.pickupDate"
                type="date"
                placeholder="Выберите дату"
                format="DD/MM/YYYY"
                :disabled-date="datePickerOptions"
                :disabled="!dataForm.applicationCargoPickup.isCargoPickup"
                @change="changeDate('pickupDate')"
              />
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item class="application-cargo-pickup__time-picker margin-top--10-phone align-items--flex-start">
          <el-col :span="11">
            <el-form-item label="Желаемое время забора груза">
              <el-col :span="11">
                <el-form-item
                  prop="applicationCargoPickup.cargoStartTimePickup"
                >
                  <el-time-select
                    v-model="dataForm.applicationCargoPickup.cargoStartTimePickup"
                    placeholder="С"
                    :start="time.cargoPickup.with.start"
                    :step="time.step"
                    :end="time.cargoPickup.with.end"
                    class="hidden_el-input__prefix hidden_el-input__suffix"
                    :disabled="!dataForm.applicationCargoPickup.isCargoPickup"
                    @change="changeStartTime('cargoStartTimePickup')"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="2" />
              <el-col :span="11">
                <el-form-item prop="applicationCargoPickup.cargoEndTimePickup">
                  <el-time-select
                    v-model="dataForm.applicationCargoPickup.cargoEndTimePickup"
                    placeholder="ДО"
                    :start="time.cargoPickup.before.start"
                    :step="time.step"
                    :end="time.cargoPickup.before.end"
                    class="hidden_el-input__prefix hidden_el-input__suffix"
                    :disabled="!dataForm.applicationCargoPickup.isCargoPickup"
                    @change="changeEndTime('cargoEndTimePickup')"
                  />
                </el-form-item>
              </el-col>
            </el-form-item>
            <div class="total-weight--error" v-if="checkDayToDay(dataForm.applicationCargoPickup.pickupDate) && checkCity()">
              День в день  
              <span v-if="!checkHour()">после 12:00, больше 30кг не принимается</span>
              <span v-else>до 15:00, принимаются заявки до 30кг</span> 
              
            </div>
          </el-col>
          <el-col :span="2" />
          <el-col :span="11">
            <el-form-item label="Время обеденного перерыва">
              <el-col :span="11">
                <el-form-item prop="applicationCargoPickup.startTimeLunchBreak">
                  <el-time-select
                    v-model="dataForm.applicationCargoPickup.startTimeLunchBreak"
                    :max-time="dataForm.applicationCargoPickup.endTimeLunchBreak"
                    placeholder="С"
                    start="09:00"
                    :step="time.step"
                    end="23:00"
                    class="hidden_el-input__prefix hidden_el-input__suffix"
                    :disabled="!dataForm.applicationCargoPickup.isCargoPickup"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="2" />
              <el-col :span="11">
                <el-form-item prop="applicationCargoPickup.endTimeLunchBreak">
                  <el-time-select
                    v-model="dataForm.applicationCargoPickup.endTimeLunchBreak"
                    :min-time="dataForm.applicationCargoPickup.startTimeLunchBreak"
                    placeholder="ДО"
                    start="10:00"
                    :step="time.step"
                    :end="time.cargoDelivery.before.end"
                    class="hidden_el-input__prefix hidden_el-input__suffix"
                    :disabled="!dataForm.applicationCargoPickup.isCargoPickup"
                    @change="chengeTimeLunch('endTimeLunchBreak')"
                  />
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
        </el-form-item>
      </div>

      <div class="blocks-container__item">
        <el-form-item class="align-items--flex-end_el-form-item__content">
          <el-col :span="11">
            <el-form-item
              label=""
              prop="applicationCargoPickup.deliveryToTheAddress"
            >
              <el-switch
                v-model="dataForm.applicationCargoPickup.deliveryToTheAddress"
                active-text="Доставка"
                :disabled="isPortCity(dataForm.consignee.cityTo)"
                @change="dataForm.calculator.isDelivery = dataForm.applicationCargoPickup.deliveryToTheAddress ? 'Доставка до двери' : 'Забрать на складе'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="2" />
          <el-col :span="11"> </el-col>
        </el-form-item>

        <template v-if="dataForm.applicationCargoPickup.deliveryToTheAddress">
          <el-form-item class="align-items--flex-end_el-form-item__content">
            <el-col :span="11">
              <el-form-item
                label="Адрес получателя"
                prop="applicationCargoPickup.addressConsignee"
              >
                <el-dropdown ref="addressToDropdown" trigger="contextmenu" class="addressToDropdown">
                  <div class="dropdown-input-area"></div>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item
                        v-for="(option, index) in toAddressList"
                        :key="index"
                        @click.native="setToAddress(option.value)"
                        :disabled="option.disabled"
                        v-bind:class="option.class"
                        >
                        {{option.value}}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
                <el-input
                  v-model="dataForm.applicationCargoPickup.addressConsignee"
                  placeholder="Введите адрес"
                  :disabled="!dataForm.applicationCargoPickup.deliveryToTheAddress"
                  @input="getToAddress"
                  @click="clickToAddress"
                  v-cancel-read-only
                  autocomplete="do-not-autofill"
                />
              </el-form-item>
            </el-col>
            <el-col :span="2" />
            <el-col :span="11">
              <!-- <el-form-item
                label="Дата доставки"
                prop="applicationCargoPickup.deliveryDate"
              >
                <el-date-picker
                  style="width: auto"
                  v-model="dataForm.applicationCargoPickup.deliveryDate"
                  type="date"
                  placeholder="Выберите дату"
                  firstDayWeek="2"
                  format="DD/MM/YYYY"
                  value-format="YYYY-MM-DD"
                  :disabled-date="datePickerOptionsDelivery"
                  @change="changeDate('deliveryDate')"
                />
              </el-form-item> -->
            </el-col>
          </el-form-item>

          <el-form-item class="application-cargo-pickup__time-picker margin-top--10-phone align-items--flex-end_el-form-item__content">
            <el-col :span="11">
              <!-- <el-form-item label="Желаемое время доставки"> -->
              <el-form-item label="Время работы">
                <el-col :span="11">
                  <el-form-item
                    prop="applicationCargoPickup.cargoStartTimeDelivery"
                  >
                    <el-time-select
                      v-model="dataForm.applicationCargoPickup.cargoStartTimeDelivery"
                      placeholder="С"
                      :start="time.cargoDelivery.with.start"
                      :step="time.step"
                      :end="time.cargoDelivery.with.end"
                      class="hidden_el-input__prefix hidden_el-input__suffix"
                      @change="changeStartTime('cargoStartTimeDelivery')"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="2" />
                <el-col :span="11">
                  <el-form-item
                    prop="applicationCargoPickup.cargoEndTimeDelivery"
                  >
                    <el-time-select
                      v-model="dataForm.applicationCargoPickup.cargoEndTimeDelivery"
                      placeholder="ДО"
                      :start="time.cargoDelivery.before.start"
                      :step="time.step"
                      :end="time.cargoDelivery.before.end"
                      class="hidden_el-input__prefix hidden_el-input__suffix"
                      @change="changeEndTime('cargoEndTimeDelivery')"
                    />
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="2" />
            <el-col :span="11">
              <el-form-item label="Время обеденного перерыва">
                <el-col :span="11">
                  <el-form-item
                    prop="applicationCargoPickup.startTimeLunchBreakDelivery"
                  >
                    <el-time-select
                      v-model="dataForm.applicationCargoPickup.startTimeLunchBreakDelivery"
                      :max-time="dataForm.applicationCargoPickup.endTimeLunchBreakDelivery"
                      placeholder="С"
                      start="09:00"
                      :step="time.step"
                      end="23:00"
                      class="hidden_el-input__prefix hidden_el-input__suffix"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="2" />
                <el-col :span="11">
                  <el-form-item
                    prop="applicationCargoPickup.endTimeLunchBreakDelivery"
                  >
                    <el-time-select
                      v-model="dataForm.applicationCargoPickup.endTimeLunchBreakDelivery"
                      :min-time="dataForm.applicationCargoPickup.startTimeLunchBreakDelivery"
                      placeholder="ДО"
                      start="10:00"
                      :step="time.step"
                      :end="time.cargoDelivery.before.end"
                      class="hidden_el-input__prefix hidden_el-input__suffix"
                    />
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
          </el-form-item>
        </template>
      </div>
    </div>
    <el-form-item>
      <el-col :span="11">
        <el-form-item label="Комментарий" prop="applicationCargoPickup.comment">
          <el-input
            v-model="dataForm.applicationCargoPickup.comment"
            type="textarea"
          />
        </el-form-item>
      </el-col>
    </el-form-item>
  </div>

  <div>
    <div class="bord_button">
      <el-form-item>
        <el-button
          class="button_shadow"
          type="primary"
          @click="$emit('click-button-back')"
        >
          Назад
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          class="button_send"
          type="primary"
          @click="$emit('click-button-next', [...getArrayOfRules(dataForm.applicationCargoPickup, 'applicationCargoPickup')])"
        >
          Далее
        </el-button>
      </el-form-item>
    </div>
  </div>
</div>
